import InlineFields from 'modules/expenses/components/expenses/Form/InlineFields'

import { CustomizationProps } from '../../withCustomizationFields'
import { PermissionsProps } from '../../withFieldPermissions'
import MerchantNameField from './MerchantNameField'
import MerchantTinField from './MerchantTinField'

interface Props extends PermissionsProps, CustomizationProps {}

const Vendor = (props: Props) => {
  return (
    <InlineFields>
      <MerchantNameField {...props} fieldIdentifier="merchant_name" />
      <MerchantTinField {...props} fieldIdentifier="merchant_tin" />
    </InlineFields>
  )
}

export default Vendor
